import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Button, Difficulty, DifficultyType } from '@tryhackme/thm-ui-components';
import { useNavigate } from 'react-router-dom';
import { StyledAlternativePath, StyledInfoMessage, StyledAlternativePathDetails, StyledAlternativePathImage, StyledAlternativePathDifficulty, StyledAlternativePathSummary } from './alternative-path.styles';
import { AlternativePathProps } from './alternative-path.types';
export const AlternativePath: React.FC<AlternativePathProps> = ({
  alternativePath
}) => {
  const navigate = useNavigate();
  return <StyledAlternativePath data-sentry-element="StyledAlternativePath" data-sentry-component="AlternativePath" data-sentry-source-file="alternative-path.tsx">
      <StyledInfoMessage data-sentry-element="StyledInfoMessage" data-sentry-source-file="alternative-path.tsx">
        <FontAwesomeIcon icon={faInfoCircle} style={{
        color: '#719CF9',
        paddingRight: '0.4rem'
      }} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="alternative-path.tsx" />
        <p>
          As of <strong>April 2nd</strong>, this path has been retired and is no longer available. To continue your
          learning journey, we recommend joining the path below.{' '}
          <a href="https://help.tryhackme.com/en/articles/10632551-big-changes-on-tryhackme-retiring-learning-paths" target="_blank" rel="noreferrer noopener">
            Read more
          </a>
        </p>
      </StyledInfoMessage>
      <StyledAlternativePathDetails data-sentry-element="StyledAlternativePathDetails" data-sentry-source-file="alternative-path.tsx">
        <StyledAlternativePathImage data-sentry-element="StyledAlternativePathImage" data-sentry-source-file="alternative-path.tsx">
          <img src={alternativePath.image} alt={alternativePath.title} />
        </StyledAlternativePathImage>
        <div>
          <StyledAlternativePathDifficulty data-sentry-element="StyledAlternativePathDifficulty" data-sentry-source-file="alternative-path.tsx">
            <h4>{alternativePath.title}</h4>
            {alternativePath.difficulty && <Difficulty difficulty={(alternativePath.difficulty.toLowerCase() as DifficultyType)} // ✅ Properly casted
          hasIcon isDarkVersion />}
          </StyledAlternativePathDifficulty>

          <StyledAlternativePathSummary data-sentry-element="StyledAlternativePathSummary" data-sentry-source-file="alternative-path.tsx">{alternativePath.summary}</StyledAlternativePathSummary>
          <Button color="primary" variant="solid" onClick={() => navigate(`/path/outline/${alternativePath.code}`)} data-sentry-element="Button" data-sentry-source-file="alternative-path.tsx">
            View path
          </Button>
        </div>
      </StyledAlternativePathDetails>
    </StyledAlternativePath>;
};